import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UiButtonComponent } from "./button/button.component";
import { UiLinkComponent } from "./link/link.component";
import { SpriteIconComponent } from "./sprite-icon/sprite-icon.component";

@NgModule({
  declarations: [
    UiButtonComponent,
    UiLinkComponent,
    SpriteIconComponent,
  ],
  entryComponents: [
    SpriteIconComponent,
  ],
  exports: [
    UiButtonComponent,
    UiLinkComponent,
    SpriteIconComponent,
  ],
  imports: [
    CommonModule,
  ],
})
export class UiLibraryModule { }



// WEBPACK FOOTER //
// ./src/app/ui-library/ui-library.module.ts